<ng-container [ngSwitch]="view">

  <ng-container *ngSwitchCase="'main'">
    <div
      *ngIf="companyId"
      (click)="onMoveSolid($event)"
      class="header-menu__inner"
    >
      <a
        #rightsTipContainer
        (click)="onNavigateToArticles()"
        [rtTooltip]="rightsTip"
        [position]="tooltipPosition"
        [routerLink]="['/', companyId, 'wiki']"
        [routerLinkActiveOptions]="{ exact: false, __change_detection_hack__: companyId }"
        routerLinkActive="header-menu__link_active"
        class="header-menu__link"
      >
        <lucide-icon name="book-open" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
        База знаний
      </a>
      <a
        #userTipContainer
        (click)="onNavigateToUsers()"
        [rtTooltip]="userTip"
        [position]="tooltipPosition"
        [routerLink]="['/', companyId, 'users']"
        routerLinkActive="header-menu__link_active"
        class="header-menu__link"
      >
        <lucide-icon name="users" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
        команда
      </a>
      <a [routerLink]="['/', companyId, 'learning']"
         class="header-menu__link"
         routerLinkActive="header-menu__link_active">
        <lucide-icon name="graduation-cap" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
        Обучение
      </a>
      <!--<a class="header-menu__link header-menu__link_disabled">-->
      <!--<span class="icon-scripts header-menu__icon"></span>-->
      <!--Скрипты-->
      <!--</a>-->
      <a [routerLink]="['/', companyId, 'events']"
         class="header-menu__link"
         routerLinkActive="header-menu__link_active">
        <lucide-icon name="calendar-days" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
        События
      </a>
      <div class="header-menu__active"
           [ngStyle]="{'left.px': headerActiveLineLeft,'width.px': headerActiveLineWidth}">
      </div>
    </div>
  </ng-container>

  <div class="header-menu__inner" *ngSwitchCase="'affiliate'" (click)="onMoveSolid($event)">
    <a [routerLink]="['/affiliate/balance']"
       class="header-menu__link"
       #rla="routerLinkActive"
       routerLinkActive="header-menu__link_active">
      <lucide-icon name="wallet" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
      Баланс
    </a>
    <a [routerLink]="['/affiliate/users']"
       class="header-menu__link"
       routerLinkActive="header-menu__link_active">
      <lucide-icon name="users" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
      Пользователи
    </a>
    <a [routerLink]="['/affiliate/link']"
       class="header-menu__link"
       routerLinkActive="header-menu__link_active">
      <lucide-icon name="link" class="header-menu__icon" [size]="18" aria-hidden="true"></lucide-icon>
      Ссылка и реклама
    </a>
    <div class="header-menu__active"
         [ngStyle]="{'left.px': headerActiveLineLeft,'width.px': headerActiveLineWidth}">
    </div>
  </div>
</ng-container>
<ng-template #userTip>
  <rt-onboarding-tooltip
    [lines]="[.5, .2, .2, .2]"
    arrow="top"
  >
    <p>
      Давайте добавим людей в вашу базу знаний
    </p>
    <p>
      Перейдите в модуль<br>
      <lucide-icon name="users" class="rt-color-white header-menu__tip-icon" [size]="16" aria-hidden="true"></lucide-icon>
      команда
    </p>
  </rt-onboarding-tooltip>
</ng-template>
<ng-template #rightsTip>
  <rt-onboarding-tooltip
    [lines]="[1, 1, 1, .5]"
    arrow="top"
  >
    <p>
      Теперь давайте назначим права доступа к разделам отделу «Разработчики»
    </p>
    <p>
      Перейдите в модуль
      <br>
      <lucide-icon name="book-open" class="rt-color-white header-menu__tip-icon" [size]="16" aria-hidden="true"></lucide-icon>
      База знаний
    </p>
  </rt-onboarding-tooltip>
</ng-template>
